export const OPD_ORDER_MEDICATION_PERMISSIONS = [
  'role:menu_admin',
  'role:menu_doctor',
  'role:menu_doctor_opd',
  'role:menu_doctor_general',
  'role:opd_order_med',
]

const ROLE_PREFIX = 'role:'
const CKDOCTOR_ROLE_PREFIX = 'role:ckdoctor:'

const toPermissionList = (permissions) => {
  if (Array.isArray(permissions)) return permissions
  if (!permissions) return []

  return [permissions]
}

const getPermissionCode = (permission) => {
  if (typeof permission === 'string') return permission

  return (
    permission?.role ||
    permission?.path ||
    permission?.name ||
    permission?.code ||
    ''
  )
}

export const normalizePermissionCode = (permission) => {
  const permissionCode = `${getPermissionCode(permission) || ''}`.trim()

  if (!permissionCode) return ''
  if (permissionCode.startsWith(CKDOCTOR_ROLE_PREFIX)) {
    return permissionCode.slice(CKDOCTOR_ROLE_PREFIX.length)
  }
  if (permissionCode.startsWith(ROLE_PREFIX)) {
    return permissionCode.slice(ROLE_PREFIX.length)
  }

  return permissionCode
}

export const hasAnyPermission = (userPermissions = [], rules = []) => {
  const normalizedPermissions = toPermissionList(userPermissions)
    .map(normalizePermissionCode)
    .filter(Boolean)
  const normalizedRules = toPermissionList(rules)
    .map(normalizePermissionCode)
    .filter(Boolean)

  if (normalizedPermissions.includes('menu_admin')) return true

  return normalizedRules.some((rule) => normalizedPermissions.includes(rule))
}

export const canKeyOpdOrderMedication = (userPermissions = []) =>
  hasAnyPermission(userPermissions, OPD_ORDER_MEDICATION_PERMISSIONS)
